import { FormLayout, TextField } from "@shopify/polaris";
import TimeField from "../TimeField/TimeField.js";
import { useCallback } from "react";

const ScheduledSettings = ({ input }) => {

  const handleChangeDays = useCallback((value) => {
    input.onChange({ ...input.value, scheduledEveryDays: value });
  }, [input]);

  return (
    <FormLayout>
      <TimeField input={input} />
      <TextField
        label="How often (every X days)"
        autoComplete="off"
        type="number"
        value={input.value.scheduledEveryDays}
        onChange={handleChangeDays}
        suffix="days"
        min={0}
      />
    </FormLayout>
  );
};

export default ScheduledSettings;